<template>
    <div class="trainServices">
        <banner></banner>
        <div class="container">
            <div class="topTabBox">
                <div class="boxTit">卓创数据指数</div>
                <div class="tabTit">
                    <div class="titItem" v-for="(item, titIndex) in onlineTitList" :key="item._id"
                        :class="{ active: item.active }" @click="tabTitClick(titIndex, item._id, 'online')">{{ item.zsmc }}
                    </div>
                </div>

                <div class="tabContent">
                    <div class="contLeft">
                        <div class="title">农产品近期价格指数</div>
                        <div class='titleBox'>
                            <div class='titleWrite'>日期</div>
                            <div class='titleWrite'>指数值</div>
                            <div class='titleWrite'>涨跌值</div>
                            <div class='titleWrite'>涨跌幅</div>
                        </div>
                        <div class='conBox' v-for='(item, index) in zhList' :key='index'>
                            <div class='conWrite'>{{ item.date.slice(0, 10) }}</div>
                            <div class='conWrite'>{{ item.sz }}</div>
                            
                            <div class='conWrite' v-if="item.zdValue<0" style='color: #07B40A;'>{{ item.zdValue }}</div>
                            <!-- <div class='conWrite' v-if="item.zdValue=='0' " style='color: #191919;'>-</div> -->
                            <div class='conWrite' v-if="!item.zdValue " style='color: #191919;'>-</div>

                            <div class='conWrite'  v-if="item.zdValue>0" style='color: red;'>{{ item.zdValue }}</div>

                            <div class='conWrite' v-if = 'item.zdScope<0' style='color: #07B40A;'>{{ item.zdScope }}%</div>
                            <div class='conWrite' v-if = "!item.zdScope"  style='color: #191919;'>-</div>
                            <div class='conWrite'  v-if = 'item.zdScope>0' style='color: red;'>{{ item.zdScope }}%</div>

                        </div>

                    </div>
                    <div class='contRight'>
                        <div class='title'></div>
                        <div class='echartsBox'>
                            <div ref="chartContainerline" style="width: 100%; height: 100%; background-color: #fff;">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="botTabBox">
                <div class="boxTit">数据报告中心</div>
                <div class="tabTit">
                    <div class="titItem" v-for="(item, titIndex) in offlineTitList" :key="item._id"
                        :class="{ active: item.active }" @click="tabTitClick(titIndex, item._id, 'offline')">{{ item.flmc }}
                    </div>
                </div>
                <div class="tabContent">
                    <div class="contentItem" v-for="(item, index) in offlineContentList" :key="index">
                        <!-- <div class="leftBox">
                            <div class="bigT">{{ item.day }}</div>
                            <div>{{ item.month }}<span class="gap">月</span>{{ item.year }}</div>
                        </div> -->
                        <div class="midBox">
                            <div class="tit">{{ item.bgmc }}</div>
                            <div class="desc">{{ item.bgjj }}</div>
                        </div>
                        <div class="rightBox">
                            <div class="btn colorBtn" @click="goPage(item.bglj)">立即查看</div>

                        </div>
                    </div>
                </div>
                <div class="paginationBox">
                    <el-pagination background layout="prev, pager, next" @size-change="e => { sizeChange(e, 'offline') }"
                        @current-change="e => { currentChange(e, 'offline') }" :page-size="pageInfo1.pageSize"
                        :total="pageInfo1.count" />
                </div>
            </div>
        </div>

        <div class="btmBox" id="btmBox">
            <div class="boxTit">数据产品超市</div>
            <div class='sjcpBox'>

                <el-carousel :interval="5000" :arrow="always" height='650px'  indicator-position="outside" class = 'carouselBox'>
                    <el-carousel-item v-for="(item, index) in shopList" :key="index">
                        <div class='listBox'>

                            <div class='listItem' v-for='(v, k) in item' :key='k'>
                                <div class='zhoubao'>
                                    <div class='zbName'>{{ v.cpmc }}</div>
                                    <img :src="commenUrl + v.zstp" class='titleImg' alt="" v-if='v.zstp'>
                                </div>
                                <div class='itemBottom'>
                                    <div class='nrmk'>
                                        <div class='zbnrbt'>服务内容</div>
                                        <div class='nrWrite'>{{ v.fwnr }}</div>
                                    </div>
                                    <div class='nrmk'>
                                        <div class='zbnrbt'>应用场景</div>
                                        <div class='nrWrite'>{{ v.yycj }}</div>
                                    </div>
                                    <div class='nrmk'>
                                        <div class='zbnrbt'>服务对象</div>
                                        <div class='nrWrite'>{{ v.fwdx }}</div>
                                    </div>
                                    <div class='qwcg' @click=goPage(v.lj)>前往采购</div>
                                </div>
                            </div>

                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        
    </div>
</template>
<script>
import { ref, getCurrentInstance, reactive, nextTick, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import banner from '@/components/banner.vue'
import * as echarts from 'echarts';

export default {
    name: "trainServices",
    props: {
        themeColor: {
            type: String,
            default: 'blue'
        },
    },

    components: { banner },
    setup() {
        onMounted(() => {
            getOnlineTypeList()
            getsjcpShop()
        })

        const { proxy } = getCurrentInstance();
        const chartContainerline = ref(null);
        let myChart = null;
        const router = useRouter();
        const route = useRoute()
        const yData = ref([])
        const xData = ref([])

        const pageInfo = ref({
            pageSize: 8,
            pageNo: 1,
            count: 0
        })
        const pageInfo1 = ref({
            pageSize: 6,
            pageNo: 1,
            count: 0
        })

        

        // 卓创数据指数nav
        const onlineTitList = ref([])
        const getOnlineTypeList = () => {
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_ZCINDEXTYPE',
                method: "post",
                data: {}
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    onlineTitList.value = res.data.result
                    nextTick(() => {
                        if (onlineTitList.value.length > 0) {
                            onlineTitList.value[0].active = true
                            getechartsData(onlineTitList.value[0]._id)
                            getzhList(onlineTitList.value[0]._id)
                        }
                    })

                }
            }).catch((err) => {
                console.log(err);
            })
        }

         //农产品获取近期价格指数
         const zhList = ref([])
        const getzhList = (id) => {
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_NEARPRICEINDEX',
                method: "post",
                data: {
                    "zs": id
                }
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    zhList.value = res.data.result.list
                    // zhList.value.map((item,index) =>{
                    //     item.zdScope = (item.zdScope * 100)/100
                    // })

                }
            }).catch((err) => {
                console.log(err);
            })
        }

        //获取echarts列表
        const getechartsData = (id) => {
            xData.value = []
            yData.value = []
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_LINEGRAPH',
                method: "post",
                data: {
                    "zs": id
                }
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    res.data.result.map((item, index) => {
                        xData.value.push(item.rq.slice(0, 10))
                        yData.value.push(item.sz)
                    }
                    )
                }
                echartsInit()
            }).catch((err) => {
                console.log(err);
            })
        }


        function echartsInit() {
            if (chartContainerline.value) {
                myChart = echarts.init(chartContainerline.value);
                const option = {
                    backgroundColor: "#fff",

                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            lineStyle: {
                                color: "#57617B",
                            },
                        },
                    },

                    grid: {
                        top: '5%',
                        left: "10%",
                        right: "8%",
                        bottom: "0%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: "category",
                            boundaryGap: false,
                            axisLine: {
                                lineStyle: {
                                    color: "#A5AAB5",
                                },
                            },
                            axisLabel: {
                                margin: 10,
                                textStyle: {
                                    fontSize: 10,
                                    color: '#A5AAB5'
                                },
                            },
                            axisTick: {
                                show: false
                            },
                            data: xData.value
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            axisTick: {
                                show: false,
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: "#A5AAB5",
                                },
                            },
                            axisLabel: {
                                margin: 10,
                                textStyle: {
                                    fontSize: 14,
                                    color: '#A5AAB5'
                                },
                            },
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    color: "#57617B",
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "指数值",
                            type: "line",
                            smooth: true,
                            lineStyle: {
                                normal: {
                                    width: 2,
                                },
                            },

                            itemStyle: {
                                normal: {
                                    color: "#1663FF",
                                },
                            },
                            data: yData.value,
                        },

                    ],
                };
                myChart.setOption(option);
                // 监听窗口大小变化，自适应图表
                window.addEventListener('resize', () => {
                    myChart.resize();
                });
            }
        }


       



       


        //类型切换
        const currentOnlineId = ref('')
        const currentOfflineId = ref('')
        const tabTitClick = (titIndex, id, type) => {
            if (type == 'online') {
                // 卓创数据指数
                currentOnlineId.value = id;
                onlineTitList.value.forEach((item, index) => {
                    item.active = index == titIndex ? true : false
                })
                pageInfo.value.pageNo = 1
                getechartsData(currentOnlineId.value)
                getzhList(currentOnlineId.value)

            } else {
                // 数据报告中心的处理
                currentOfflineId.value = id;
                offlineTitList.value.forEach((item, index) => {
                    item.active = index == titIndex ? true : false
                })
                pageInfo1.value.pageNo = 1
                getOfflineContentList(currentOfflineId.value)
            }
        }

        //分页事件
        const sizeChange = (e, type) => {
            
            if (pageInfo1.value.pageSize == e) return;
            pageInfo1.value.pageSize = e;
            getOfflineContentList(currentOfflineId.value)
        

        };
        const currentChange = (e, type) => {
           
            if (pageInfo1.value.pageNo == e) return;
            pageInfo1.value.pageNo = e;
            getOfflineContentList(currentOfflineId.value)
            
        };






        // 数据报告中心nav
        const offlineTitList = ref([])
        const getOfflineTypeList = () => {
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_BGZXTYPE',
                method: "post",
                data: {}
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    offlineTitList.value = res.data.result
                    console.log(offlineTitList.value, 99999)
                    nextTick(() => {
                        if (offlineTitList.value.length > 0) {
                            offlineTitList.value[0].active = true
                            getOfflineContentList(offlineTitList.value[0]._id)
                        }
                    })
                }
            }).catch((err) => {
                console.log(err);
            })
        }
        getOfflineTypeList()


        //数据报告中心列表
        const offlineContentList = ref([])
        const getOfflineContentList = (id) => {
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_BGFINDPAGE',
                method: "post",
                data: {
                    "fl": id,
                    "pageInfo": pageInfo1.value
                }
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    offlineContentList.value = res.data.result.list.map(item => {
                        // const date = new Date(item.fbrq);
                        // item.day = date.getDate()
                        // item.month = (date.getMonth() + 1).toString().padStart(2, '0')
                        // item.year = date.getFullYear()
                        if(item.fbrq){
                            item.day = item.fbrq.slice(8,10)
                            item.month = item.fbrq.slice(5,7)
                            item.year = item.fbrq.slice(0,4)
                        }
                        

                        return item
                    })
                    pageInfo1.value.pageNo = res.data.result.pageNo
                    pageInfo1.value.pageSize = res.data.result.pageSize
                    pageInfo1.value.count = res.data.result.count
                }
            }).catch((err) => {
                console.log(err);
            })
        }
        //获取数据产品超市列表
        const shopList = ref([])
        const getsjcpShop = () => {
            proxy.$request({
                url: 'N_QPSTZX_ZCDATA_SHOPFINDPAGE',
                method: "post",
                data: {
                    pageInfo: {
                        "pageSize": "50",
                        "pageNo": "1"
                    }
                }
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    shopList.value = groupArray(res.data.result.list, 4)
                    console.log(shopList.value, 898989898)


                }
            }).catch((err) => {
                console.log(err);
            })
        }

        const groupArray = (arr, size) => {//轮播图数组转换
            const result = [];
            for (let i = 0; i < arr.length; i += size) {
                result.push(arr.slice(i, i + size));
            }
            return result;
        }
        //页面跳转
        const goPage = (url) => {
            window.open(url);
        };
        return {
            onlineTitList,
            tabTitClick,
            currentOnlineId,
            currentOfflineId,
            pageInfo,
            pageInfo1,
            sizeChange,
            currentChange,
            offlineTitList,
            offlineContentList,
            goPage,
            groupArray,
            xData,
            yData,
            getzhList,
            zhList,
            getechartsData,
            shopList,
            getsjcpShop,
            echartsInit,
            chartContainerline
        }
    }
}
</script>
<style lang="less" scoped>
.trainServices {
    width: 100%;
    height: 100%;
    background: #F7F7F7;
    box-sizing: border-box;
    padding-bottom: 50px;

    div {
        box-sizing: border-box;
        color: #191919;
        font-size: 16px;
        line-height: 22px;
        font-family: PingFangSC, PingFang SC;
    }

    img {
        width: 100%;
        height: 100%;
    }

    .boxTit {
        font-weight: 600;
        font-size: 36px;
        line-height: 50px;
        text-align: center;
    }

    .container {
        .tabTit {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            margin-bottom: 40px;

            .titItem {
                font-weight: 400;
                font-size: 18px;
                color: #191919;
                line-height: 28px;
                padding-bottom: 10px;
                margin: 0 40px;
                cursor: pointer;

                &.active {
                    font-weight: 600;
                    font-size: 20px;
                    border-bottom: 3px solid #191919;
                    ;
                }
            }
        }

        .paginationBox {
            display: flex;
            justify-content: center;
        }

        .topTabBox {
            width: 1200px;
            margin: 0 auto;
            padding-bottom: 60px;

            .boxTit {
                padding: 60px 0 30px;
            }

            .tabContent {
                display: flex;
                flex-wrap: wrap;
                // gap: 40px 20px;
                height: 551px;
                background: #fff;
                display: flex;
                justify-content: space-between;
                padding: 0 20px;
                border-radius: 20px;

                .contLeft {
                    width: 49%;
                    height: 100%;

                    .title {
                        font-size: 18px;
                        font-weight: 600;
                        color: #191919;
                        line-height: 25px;
                        margin: 30px 0 20px;
                    }

                    .titleBox {
                        display: flex;
                        justify-content: space-around;
                        background: #F0F5FF;
                        padding: 0 30px;
                        box-sizing: border-box;

                        .titleWrite {
                            height: 46px;
                            width: 25%;
                            display: flex;
                            align-items: center;
                            font-size: 14px;
                            color: #191919;
                            font-weight: 600;
                        }
                    }

                    .conBox {
                        display: flex;
                        justify-content: space-around;
                        background: #fff;
                        padding: 0 30px;
                        box-sizing: border-box;
                        box-shadow: 0px 1px 0px 0px #F0F5FF;

                        .conWrite {
                            height: 46px;
                            width: 25%;
                            display: flex;
                            align-items: center;
                            font-size: 14px;
                            color: #191919;
                            font-weight: 600;

                        }
                    }
                }

                .contRight {
                    width: 49%;
                    height: 100%;

                    .echartsBox {
                        width: 100%;
                        height: 420px;
                        background: pink;
                        margin-top: 75px;
                    }
                }

                // .contentItem{
                //     width: calc((100% - 60px) / 4);
                //     box-sizing: border-box;
                //     font-weight: 400;
                //     cursor: pointer;
                //     .imgBox{
                //         width: 100%;
                //         height: 223px;
                //         background: #EEF1FF;
                //         border-radius: 20px;
                //         overflow: hidden;
                //         display: flex;
                //         justify-content: center;
                //         align-items: center;
                //         margin-bottom: 26px;
                //         .defaultImg{
                //             width: 247px;
                //             height: 164px;
                //         }
                //     }
                //     .contentTit{
                //         font-weight: 600;
                //         font-size: 24px;
                //         line-height: 33px;
                //         height: 33px;
                //         white-space: nowrap;
                //         overflow: hidden;
                //         text-overflow: ellipsis;
                //         margin-bottom: 10px;
                //     }
                //     .contentDesc{
                //         width: 100%;
                //         height: 56px;
                //         line-height: 28px;
                //         display: -webkit-box;
                //         -webkit-box-orient: vertical;
                //         -webkit-line-clamp: 2;
                //         overflow: hidden;
                //         text-overflow: ellipsis;
                //     }
                // }
            }

            .paginationBox {
                margin-top: 30px;
            }
        }

        .botTabBox {
            width: 100%;
            height: 850px;
            background-image: url(../../assets/images/peixunbg.jpg);
            background-size: cover;
            background-repeat: no-repeat;
            display: flex;
            flex-direction: column;
            padding-bottom: 50px;

            .paginationBox {
                margin-top: auto;
            }

            .boxTit {
                padding: 50px 0 30px;
                color: #FFFFFF;
            }

            .tabTit {
                .titItem {
                    color: #FFFFFF;

                    &.active {
                        border-bottom: 3px solid #FFFFFF;
                    }
                }
            }

            .tabContent {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                flex-wrap: wrap;
                gap: 20px;

                .contentItem {
                    width: 590px;
                    height: 164px;
                    padding: 33px 20px 33px 0px;
                    background: linear-gradient(133deg, #FFFFFF 0%, rgba(255, 255, 255, 0.39) 100%);
                    border-radius: 20px;
                    display: flex;

                    .leftBox {
                        width: 100px;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        justify-content: center;
                        align-items: center;
                        font-weight: 500;
                        font-size: 20px;
                        color: #595959;
                        line-height: 28px;

                        .bigT {
                            font-weight: 900;
                            font-size: 46px;
                            line-height: 56px;
                            color: #191919;
                        }

                        .gap {
                            margin-right: 8px;
                        }
                    }

                    .midBox {
                        flex: 1;
                        margin: 0 20px;
                        cursor: pointer;

                        .tit {
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 33px;
                            margin-bottom: 15px;
                            max-width: 304px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        .desc {
                            font-weight: 500;
                            font-size: 14px;
                            color: #595959;
                            line-height: 26px;
                            height: 52px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                    }

                    .rightBox {
                        width: 106px;
                        height: 100%;
                        display: flex;
                        align-items: center;

                        .btn {
                            width: 106px;
                            height: 34px;
                            border-radius: 17px;
                            border: 1px solid #191919;
                            text-align: center;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            font-size: 14px;
                            cursor: pointer;
                            background: transparent;
                        }

                        .colorBtn {
                            border: 1px solid #191919;
                            color: 000;
                        }

                        .colorBtn:hover {
                            background: #191919;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
    }

    .btmBox {
        margin: 0 auto 40px;
        width: 1200px;

        .boxTit {
            padding: 60px 0 40px;
        }

        .sjcpBox {
            width: 100%;
            height: 620px;
            .carouselBox{
                ::v-deep(.el-carousel__indicators--outside) .el-carousel__indicator.is-active button {
                    background-color: #1663FF; /* 示例：将选中指示器的背景色改为红色 */
                    height:8px;
                    width:60px;
                    border-radius: 8px;
                }

                ::v-deep(.el-carousel__indicators--outside) .el-carousel__indicator button {
                    // background-color: #1663FF; /* 示例：将选中指示器的背景色改为红色 */
                    height:8px;
                    width:60px;
                    border-radius: 8px;
                }
            }

            .listBox {
                display: flex;
                width: 100%;
                height: 620px;

                .listItem {
                    width: 24%;
                    background: #fff;
                    border-radius: 20px;
                    margin-right: 20px;

                    .zhoubao {
                        width: 100%;
                        height: 86px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0 30px;
                        background: #E8F0FF;

                        .zbName {
                            flex: 1;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 600;
                            font-size: 26px;
                            height: 42px;
                            color: #121C30;
                            text-align: left;
                            line-height: 42px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            padding-right: 30px;
                        }

                        .titleImg {
                            width: 36px;
                            height: 36px;
                        }

                    }

                    .itemBottom {
                        padding: 20px 30px 0;

                        // .zbName{
                        //     width: 100%;
                        //     height: 37px;
                        //     font-family: PingFangSC, PingFang SC;
                        //     font-weight: 600;
                        //     font-size: 26px;
                        //     color: #121C30;
                        //     line-height: 37px;
                        //     text-align: left;
                        //     font-style: normal;
                        //     margin: 30px 0 15px;
                        //     overflow: hidden;
                        //     text-overflow: ellipsis;
                        //     white-space: nowrap;
                        // }
                        .nrmk {
                            border-bottom: 1px solid #EBEBEB;
                            margin-bottom: 15px;
                            height: 123px;

                            // background:pink;
                            .zbnrbt {
                                width: 100%;
                                height: 40px;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 16px;
                                color: #747C8D;
                                line-height: 40px;
                                text-align: left;
                                font-style: normal;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }

                            .nrWrite {
                                height: 80px;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 600;
                                font-size: 20px;
                                color: #676D7A;
                                line-height: 40px;
                                text-align: left;
                                font-style: normal;
                                margin-bottom: 11px;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                /* 限制行数为3 */
                                overflow: hidden;
                            }
                        }

                        .qwcg {
                            width: 156px;
                            height: 46px;
                            border-radius: 23px;
                            border: 1px solid #191919;
                            margin: 40px auto 0;
                            display: flex;
                            justify-content: space-around;
                            align-items: center;
                            color: #191919;
                            font-size: 14px;
                            cursor: pointer;
                        }
                        .qwcg:hover {
                            width: 156px;
                            height: 46px;
                            border-radius: 23px;
                            border: 1px solid #191919;
                            margin: 40px auto 0;
                            display: flex;
                            justify-content: space-around;
                            align-items: center;
                            color: #fff;
                            font-size: 14px;
                            cursor: pointer;
                            background:#191919;
                        }
                    }

                }
            }
        }
    }
}

@media (min-width: 1680px) {
    .trainServices {
        .container {
            .topTabBox {
                width: 1600px;
            }

            .botTabBox {
                .tabContent {
                    width: 1600px;

                    .contentItem {
                        width: 790px;
                        height: 164px;

                        .midBox {
                            margin: 0 30px;

                            .tit {
                                max-width: 484px;
                            }
                        }
                    }
                }
            }
        }

        .btmBox {
            width: 1600px;
        }
    }
}
</style>


